import { z } from "zod";
import { ProviderKeySchema } from "./common";

// ============================================================================
// INBOX SCHEMAS
// ============================================================================

export const InboxSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  provider: ProviderKeySchema,
  connectionId: z.string(),
  email: z.string().email().optional(),
  unreadCount: z.number().int().nonnegative(),
  totalCount: z.number().int().nonnegative(),
  lastSyncAt: z.string().datetime().optional(),
  isActive: z.boolean(),
  color: z.string(),
  icon: z.string(),
  groupId: z.string().uuid().optional(),
}).strict();

export type Inbox = z.infer<typeof InboxSchema>;

export const InboxGroupSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  description: z.string().optional(),
  color: z.string(),
  inboxIds: z.array(z.string().uuid()),
  inboxes: z.array(InboxSchema),
  isCollapsed: z.boolean(),
  order: z.number().int().nonnegative(),
}).strict();

export type InboxGroup = z.infer<typeof InboxGroupSchema>;
